import { DASHBOARD_ACTIONS } from 'Actions/index';
import { DATA_LOAD_STATUS } from 'Utils/constants';

const initialState = {
  contentStatus: DATA_LOAD_STATUS.LOADING,
  labels: [],
  moves: [],
  airportTransfers: [],
  housings: [],
  shortStays: [],
  tickets: [],
  totalRequests: 0,
  totalRelocations: 0,
  budgetSpent: 0,
  feedback: 0,
};

const { SET_DASHBOARD_DATA, SET_DASHBOARD_DATA_LOADING } = DASHBOARD_ACTIONS;

const dashboard = (state = initialState, action) => {
  switch (action.type) {
    case SET_DASHBOARD_DATA:
      return {
        ...state,
        contentStatus: DATA_LOAD_STATUS.LOADED,
        ...action.payload,
      };
    case SET_DASHBOARD_DATA_LOADING:
      return {
        ...state,
        contentStatus: DATA_LOAD_STATUS.LOADING,
      };
    default:
      return state;
  }
};

export default dashboard;
